const buildAdminMicroAppsQueryKey = (): string[] => ['admin-micro-apps'];

export default buildAdminMicroAppsQueryKey;
